import React, { ReactNode, useContext, useEffect, useState } from 'react';

import AuvikContext from '@totem/components/settings/sections/auvikMapping/AuvikContext';
import AuvikBuildingSelectModal from '@totem/components/settings/sections/auvikMapping/BuildingSelectModal';
import { TenantReportRecord } from '@totem/components/settings/sections/auvikMapping/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { AUVIK_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const AuvikMappingContainer = ({ children }: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isSending, setIsSending] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [mappingData, setMappingData] = useState<TenantReportRecord[]>([]);
  const [selectedAction, setSelectedAction] = useState<string>('');
  const [selectedData, setSelectedData] = useState<TenantReportRecord>(null);

  useEffect(() => {
    setRefreshData(true);
  }, [userProfile.organization.id]);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);
      if (isSending) {
        return;
      }
      const endpoint = `${AUVIK_ENDPOINT}/tenants`;

      fetch(`${endpoint}`, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: TenantReportRecord[]) => {
          setMappingData(result);
        })
        .then(() => {
          setIsSending(false);

          setIsLoading(false);
        });

      setIsSending(true);
    }
  }, [refreshData, getApiToken]);

  const handleAction = (action: string, tenantRecord: TenantReportRecord) => {
    setSelectedAction(action);

    setSelectedData(tenantRecord);
  };

  const handleActionComplete = (doRefresh: boolean) => {
    setSelectedAction('');

    setSelectedData(null);
    if (doRefresh) {
      setRefreshData(true);
    }
  };

  return (
    <AuvikContext.Provider
      value={{
        data: mappingData,
        loading: isLoading,
        onAction: handleAction,
        onActionComplete: handleActionComplete,
      }}
    >
      <div>{children}</div>
      {selectedAction === 'showMappingDialog' && selectedData !== null && (
        <AuvikBuildingSelectModal
          visible={selectedAction === 'showMappingDialog'}
          tenantRecord={selectedData}
        />
      )}
    </AuvikContext.Provider>
  );
};

export default AuvikMappingContainer;
